import { useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import "./with-sidebar.css";

const WithSidebar = ({ children, pageTitle, breadcrumb, listHeaders }) => {

  const privileges = window.localStorage.getItem('privileges')
  
  return (
    <div className="with-sidebar-container">
      <div className="with-sidebar-container__sidebar">
        <Sidebar extraClass="desktop" privileges={privileges}/>
      </div>
      <div className="with-sidebar-container__content">
        <div className="bread-crumb">{breadcrumb}</div>
        <div className="container__header">{pageTitle}</div>
        <div className="list-headers">{listHeaders}</div>
        <div className="main_content">{children}</div>
      </div>
    </div>
  );
};

export default WithSidebar;
